export default __webpack_public_path__ + "assets/3f07d9c1da7b319d5790d9ee3bab09c8.jpeg";